import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme => ({
    title: {
        fontWeight: "bold",
        fontSize: 24,
        color: theme.palette.grey[900],
    },
    health: {
        display: "flex",
        alignSelf: "center",
        margin: "6px 8px 0px 0px",
    },
    titleRow: {
        display: "flex",
        alignItems: "start",
    },
    row: {
        display: "flex",
        alignItems: "center",
        fontSize: 16,
    },
    icon: {
        marginRight: 8,
        color: theme.palette.grey[700],
    },
    tooltip: {
        fontSize: "1.5em",
    },
    liveUnitIcon: {
        width: "24px",
        height: "24px",
        marginRight: "8px",
        objectFit: "cover",
        opacity: 0.6,
    },
    infoText: {
        color: theme.palette.grey[700],
    },
}));
